module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin vjs-big-play-centered",
    attrs: {
      "options": _vm.playerOptions
    },
    on: {
      "ended": function($event) {
        _vm.onPlayerEnded($event)
      },
      "pause": function($event) {
        _vm.onPlayerPause($event)
      },
      "play": function($event) {
        _vm.onPlayerPlay($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a12d4e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/CusVideo.vue
// module id = 479
// module chunks = 1